module.exports = __webpack_public_path__ + "static/media/user-ico.60e1ed86.svg";